import React from "react";

import SectionContainer from "core/SectionContainer";
import Button from "core/Button";
import Heading from "core/Heading";
import SearchAndBrowseIconGrid from "icons/SearchAndBrowseIconGrid";

import colors from "core/colors";

import useLoadMore from "frontend/hooks/useLoadMore";

import { ButtonContainer, StyledA } from "./styles";

import { GET_SIMILAR_ICONS_DATA } from "icons/SimilarIcons/queries";

import { convertPxToRem } from "frontend/components/helpers";

const BrowseIconsSimilar = ({ match }) => {
    const { items, loading, loadMore, totalCount } = useLoadMore({
        limit: 200,
        query: GET_SIMILAR_ICONS_DATA,
        queryVariables: { iconId: match.params.slugWithId.split("-").pop() },
        pathToListKey: "similarIcons.items",
        pathToTotalCountKey: "similarIcons.totalCount"
    });

    if (loading) return null;

    const allItemsLoaded = items && items.length >= totalCount;
    const showLoadMoreButton = !allItemsLoaded && !!items.length;

    return (
        <SectionContainer topSpacing="2xl" bottomSpacing="3xl">
            <Heading type="h2" size="xs" bottomSpacing="xl">
                Icons Related to {/* TODO: fill in href value in future PR */}
                <StyledA color={colors.fossil} href="#">
                    Name of Icon
                </StyledA>
            </Heading>
            <SearchAndBrowseIconGrid iconData={items} />
            {showLoadMoreButton && (
                <ButtonContainer>
                    <Button
                        width={convertPxToRem({ px: 160 })}
                        onClick={e => {
                            e.preventDefault();
                            loadMore();
                        }}
                    >
                        Load More
                    </Button>
                </ButtonContainer>
            )}
        </SectionContainer>
    );
};

export default BrowseIconsSimilar;
